import React from "react";
import { useSelector } from "react-redux";

import { getTenantConfig } from "@appsmith/selectors/tenantSelectors";
import { getAssetUrl } from "@appsmith/utils/airgapHelpers";

interface ContainerProps {
  title: string;
  subtitle?: React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode;
  disabledLoginForm?: boolean;
  testId?: string;
}

function Container(props: ContainerProps) {
  const { children, footer, subtitle, testId, title } = props;
  const tenantConfig = useSelector(getTenantConfig);

  return (
    <div
      className="flex flex-col items-center gap-4 absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 w-[min(480px,80%)]"
      data-testid={testId}
    >
      <div className="rounded-2xl shadow-[0_10px_40px_-10px_rgba(0,0,0,.15)] p-10 bg-white w-full">
        <img
          className="mx-auto login-img mb-[8px]"
          src={getAssetUrl(tenantConfig.brandLogoUrl)}
        />
        {children}
      </div>
      {footer}
    </div>
  );
}

export default Container;
